import 'jquery-ui';
import 'jquery-ui-touch-punch';

$( "#slider-range" ).slider({
	value: 0,
	orientation: "horizontal",
	range: "min",
	animate: true
});